import React, { useState } from 'react';
import { Button } from '@commons/button/Button';
import { DownloadChecklistForm } from '../why-use-golang/download-checklist/DownloadChecklistForm';
import cx from 'classnames';
import * as styles from './box-with-button-and-image.module.scss';

export const BoxWithButtonAndImage = ({
  children,
  downloadImage,
  buttonTitle,
  buttonHref,
  imgAlt = 'Go',
  isForm = false,
  classNames: { firstRow, descriptionContainer, imageContainer, buttonWithLink } = {},
}) => {
  const [showForm, setShowForm] = useState(false);

  const setFormHandler = () => {
    setShowForm(true);
  };
  return (
    <div className={styles.box}>
      <div className={cx(styles.firstRow, firstRow)}>
        <div className={cx(styles.descriptionContainer, descriptionContainer)}>{children}</div>
        <div className={cx(styles.imageContainer, imageContainer)}>
          <img loading="lazy" src={downloadImage} alt={imgAlt} />
        </div>
      </div>
      <div className={styles.buttonContainer}>
        {isForm ? (
          <Button onClick={setFormHandler} className={cx(styles.button, buttonWithLink)} label={buttonTitle} />
        ) : (
          <Button label={buttonTitle} className={cx(styles.button, buttonWithLink)} href={buttonHref} rel="nofollow" />
        )}
      </div>
      {isForm && <DownloadChecklistForm showForm={showForm} setShowForm={setShowForm} />}
    </div>
  );
};
